import {Component, OnDestroy, OnInit} from '@angular/core';
import {CommonService} from '../../../shared/services/common.service';
import {
  EnterDataComponent
} from '../components/enter-data/enter-data.component';
import {pluck, Subject, takeUntil} from 'rxjs';
import {Store} from '@ngrx/store';
import * as fromRoot from '../../../../state/app.state';
import {metricsData, metricsOptions} from '../core/metrics.selectors';
import {
  DeleteMetricValueListRequest,
  DeleteMetricValueRequest,
  FetchMetricsDataRequest,
  FetchMetricsOptionsRequest
} from '../core/metrics.actions';
import {MetricOptionModel} from '../../../../models/metric-option.model';
import {PageEvent} from '@angular/material/paginator';
import {MetricValueItem} from '../models/fetch-metric-values.model';
import {
  profile,
  profileData,
  selectedUserProfile
} from '../../../shared/core/shared.selectors';
import {ProfileModel} from '../../../../models/profile.model';
import {EditDataComponent} from '../components/edit-data/edit-data.component';
import {Metrics} from '../services/metrics';
import {ActivatedRoute} from '@angular/router';
import {measurements, roles} from '../../../shared/constants/common.constants';
import {
  EditDataCombinedComponent
} from '../components/edit-data-combined/edit-data-combined.component';
import {UpdateActiveGroupDetailsOnProfile} from '../../../shared/core/shared.actions';
import moment from 'moment';

@Component({
  selector: 'app-metrics-screen',
  templateUrl: './metrics-screen.component.html',
  styleUrls: ['./metrics-screen.component.css']
})
export class MetricsScreenComponent implements OnInit, OnDestroy {

  displayErrorMessage: string;
  profileData: ProfileModel = null;
  configuration: {} = null;
  roleDecorators = {
    1: {
      label: 'Coach',
      color: '#E50808'
    },
    2: {
      label: 'Family',
      color: '#59B3A9'
    },
  }
  pageSizeOptions = [10, 25, 50, 100]
  memberId: number;
  metricsOptions: { loading: boolean; data: MetricOptionModel[]; };
  hasMetricValuesToShow = false;
  roles = roles;
  showDisclaimerBlock: boolean = false;
  private readonly onDestroy: Subject<any> = new Subject<any>();
  private groupId: any;
  foundProfile = false;


  constructor(
    protected commonService: CommonService,
    private store: Store<fromRoot.State>,
    private metricsService: Metrics,
    private route: ActivatedRoute,
  ) {
  }

  ngOnInit() {
    // get member id if this screen is accessing by another role
    this.memberId = +this.route.snapshot.paramMap.get('memberId');
    this.groupId = +this.route.snapshot.queryParamMap.get('groupId');

    this.store.select(profile).pipe(takeUntil(this.onDestroy))
      .subscribe((profileData: any) => {
        if (!this.memberId && !this.groupId && profileData && profileData['groupId']) {
          this.groupId = profileData['groupId'];
        }
        if (profileData && profileData.role === roles.adult && !this.route.snapshot.paramMap.get('memberId')) {
          const filteredData = profileData.participants.filter(participant => !(!participant.groupId || !participant.groupStatusKey || participant.groupStatusKey === 1))
          if (filteredData.length === 0) {
            this.showDisclaimerBlock = true
          }
        }

        if (!this.memberId && profileData) {
          if (profileData.role === roles.participant && !profileData['groupId']) {
            this.showDisclaimerBlock = true
            return;
          }
          // fetch metric options
          this.fetchMetricOptions();
        }
      })

    this.store.select(selectedUserProfile)
      .pipe(takeUntil(this.onDestroy), pluck('profile'))
      .subscribe((profileData: any) => {
        if (this.memberId && !this.groupId && profileData && profileData['groupId']) {
          this.groupId = profileData['groupId'];
        }
        if (profileData && profileData?.role === roles.adult && this.route.snapshot.paramMap.get('memberId')) {
          const filteredData = profileData.participants.filter(participant => !(!participant.groupId || !participant.groupStatusKey || participant.groupStatusKey === 1))
          if (filteredData.length === 0) {
            this.showDisclaimerBlock = true
          }
        }
        // if (profileData && this.groupId) {
        //   this.findAndSwitchToGroup(profileData, this.groupId)
        // }

        if (this.memberId && profileData) {
          if (profileData.role === roles.participant && !profileData['groupId']) {
            this.showDisclaimerBlock = true
            return;
          }
          // fetch metric options
          this.fetchMetricOptions();
        }
      })

    this.metricsService.fetchMetricsOptionsErrorMessage.pipe(takeUntil(this.onDestroy))
      .subscribe((error) => {
        if (error.code === 'F-L-00275') {
          this.displayErrorMessage = 'Participant not associated with any active group';
        }
      })

    this.store.select(profileData)
      .pipe(takeUntil(this.onDestroy))
      .subscribe(data => {
        this.profileData = data?.profile;
      });

    this.store.select(metricsData)
      .pipe(takeUntil(this.onDestroy))
      .subscribe(data => {
        if (this.metricsOptions?.data?.length && this.configuration) {
          this.metricsOptions.data.forEach((item) => {
            if (this.configuration[item.code] && data[item.code]) {
              this.configuration[item.code].loading = data[item.code].loading;
              if (item.code === measurements.metricOption.height) {
                if (data[item.code].data) {
                  this.configuration[item.code].data = {
                    ...data[item.code].data,
                    list: data[item.code].data.list.map((item) => {
                      return {
                        ...item,
                        height: item.value.find((item) => item.code === measurements.metricOption.height),
                        weight: item.value.find((item) => item.code === measurements.metricOption.weight),
                      };
                    })
                  }
                } else {
                  this.configuration[item.code].data = data[item.code].data;
                }
              } else {
                this.configuration[item.code].data = data[item.code].data;
              }

              // trigger for previous page if no data found for current page until it reaches to first
              if (!data[item.code].loading && data[item.code].data && (data[item.code].data.list || []).length === 0) {
                if (data[item.code].data.hasPrev) {
                  this.requestMetricDataForOption(item, data[item.code].data.pageNumber - 1, data[item.code].data.limit)
                } else {
                  // hide metric accordion
                  item.hasValues = false;
                }
              }
            }
          })
        }
      });

    this.store.select(metricsOptions)
      .pipe(takeUntil(this.onDestroy))
      .subscribe(data => {
        this.metricsOptions = JSON.parse(JSON.stringify(data));

        // check has values to show

        // prepare datasource for each metric options
        if (this.metricsOptions?.data?.length) {
          this.configuration = {};
          this.metricsOptions.data.forEach((item) => {
            if (!item.hasValues || item.code === measurements.metricOption.weight) {
              // skip metric option which has no values
              return;
            }
            // check if there are no values for the metric
            if (!this.hasMetricValuesToShow && item.hasValues) {
              this.hasMetricValuesToShow = true;
            }

            // add table config and empty data to configuration
            let config = [
              'addedBy',
              // 'session',
              'recordedOn',
              'value',
              'menu',
            ];
            if (item.code === measurements.metricOption.height) {
              config = [
                'addedBy',
                // 'session',
                'recordedOn',
                'value1',
                'value2',
                'menu',
              ];
            }
            this.configuration[item.code] = {
              config,
              data: null,
              loading: false,
            }

            // request for metric values
            this.requestMetricDataForOption(item);
          })

          // open enter data dialog when date and group provided in url
          if (this.memberId) {
            const dateToAdd = this.route.snapshot.queryParamMap.get('date');
            if (this.groupId && dateToAdd) {
              this.enterData(dateToAdd);
              this.commonService.updateQueryParams({
                // groupId: null,
                date: null,
              })
            }
          }
        }
      });

    this.commonService
      .onNavigationEnd
      .pipe(takeUntil(this.onDestroy))
      .subscribe(d => {
        const urlParams = {
          params: this.route.snapshot.params,
          queryParams: this.route.snapshot.queryParams
        }

        const prevUrlParams = this.commonService.urlParams.getValue();

        if (d.isRouteChanged || JSON.stringify(prevUrlParams) !== JSON.stringify(urlParams)) {
         this.commonService.urlParams.next(urlParams);
        }
      });
  }

  enterData(defaultDate?:string) {
    this.commonService.openDialog({
      data: {
        component: EnterDataComponent,
        memberId: this.memberId,
        groupId: this.groupId,
        metricsOptions: this.metricsOptions?.data,
        panelWidth: 20,
        defaultDate,
      }
    })
  }

  handlePageChange(metricOption: MetricOptionModel, event: PageEvent) {
    // request for next set of data for the selected metric option
    this.requestMetricDataForOption(metricOption, event.pageIndex + 1, event.pageSize);
  }

  requestMetricDataForOption(metricOption: MetricOptionModel, pageNumber = 1, limit = this.pageSizeOptions[0]) {
    const payload = {
      metricId: metricOption.id,
      pageNumber,
      limit,
      code: metricOption.code,
      combined: metricOption.code === measurements.metricOption.height,
      ...(this.groupId ? {groupId: this.groupId} : {}),
    };

    if (this.memberId) {
      payload['userId'] = this.memberId;
    }

    this.store.dispatch(FetchMetricsDataRequest({
      payload,
    }));
  }

  handleEditValue(metricOption: MetricOptionModel, value: MetricValueItem, dataSource: any) {
    const extras = {
      metricId: metricOption.id,
      pageNumber: dataSource.pageNumber,
      limit: dataSource.limit,
      code: metricOption.code,
      combined: metricOption.code === measurements.metricOption.height,
    }

    if (this.memberId) {
      extras['userId'] = this.memberId;
    }

    if (this.groupId) {
      extras['groupId'] = this.groupId;
    }

    // open edit dialog
    this.commonService.openDialog({
      data: {
        component: metricOption.code === measurements.metricOption.height ? EditDataCombinedComponent : EditDataComponent,
        memberId: this.memberId,
        metricOption,
        metricValue: value,
        extras,
        panelWidth: 20
      }
    })
  }

  handleDeleteValue(metricOption: MetricOptionModel, value: MetricValueItem, dataSource: any) {
    const extras = {
      metricId: metricOption.id,
      pageNumber: dataSource.pageNumber,
      limit: dataSource.limit,
      code: metricOption.code,
      combined: metricOption.code === measurements.metricOption.height,
    }

    if (this.memberId) {
      extras['userId'] = this.memberId;
    }

    if (this.groupId) {
      extras['groupId'] = this.groupId;
    }

    this.commonService.openConfirmationDialog({
      data: {
        message: 'Are you sure you want to delete?',
        submitText: 'Yes',
        handleSubmit: () => {
          this.commonService.closeDialog();

          if (metricOption.code === measurements.metricOption.height) {
            // call multiple delete api
            this.store.dispatch(DeleteMetricValueListRequest({
              payload: {
                values: (<any>value.value).map((value) => ({valueId: value.id})),
                extras,
              }
            }))
          } else {
            // call delete api
            this.store.dispatch(DeleteMetricValueRequest({
              payload: {
                valueId: value.id,
                extras,
              }
            }))
          }
        },
        cancelText: 'No',
        handleCancel: () => {
          this.commonService.closeDialog()
        }
      }
    });
  }

  ngOnDestroy() {
    this.onDestroy.next(null);
    this.onDestroy.complete();
  }

  private fetchMetricOptions() {
    this.foundProfile = true;

    this.store.dispatch(FetchMetricsOptionsRequest({
      payload: {
        ...(this.memberId ? {userId: this.memberId} : {}),
        ...(this.groupId ? {groupId: this.groupId} : {}),
      }
    }));
  }

  findAndSwitchToGroup(profileData, groupId) {
    const foundGroupData = (profileData.groups || []).find((item) => item.groupId == groupId);
    if (foundGroupData) {
      this.store.dispatch(UpdateActiveGroupDetailsOnProfile(foundGroupData));
    }
  }

  getTodayDate(): string {
    return moment().format('YYYY-MM-DD');
  }
  protected readonly Intl = Intl;
}
